import { MapPin } from "lucide-react";
import { CEMITERIOS, BRAND } from "@/data/products";
import { waLink } from "@/lib/whatsapp";
import { trackWhatsAppClick } from "@/lib/analytics";

export const Cemiterios = () => {
  return (
    <section id="cobertura" className="py-20 md:py-28 bg-white border-y border-[#E5E3DB]">
      <div className="container-wide grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <span className="overline">Cobertura de entrega</span>
          <h2 className="font-serif text-4xl md:text-5xl text-[#2D4A3E] leading-tight mt-3">
            Entregamos em todos os cemitérios do município do Rio
          </h2>
          <p className="mt-5 text-[#5C5C5C] leading-relaxed">
            Operamos 24 horas com motoboys e vans dedicadas para garantir entrega rápida em cada velório,
            capela ou cerimônia. Não encontrou seu cemitério na lista? Fale com a gente — provavelmente atendemos.
          </p>
          <a
            href={waLink("Olá, preciso entregar uma coroa no cemitério/capela: ")}
            target="_blank" rel="noreferrer"
            onClick={() => trackWhatsAppClick("cobertura_cta")}
            data-testid="coverage-whatsapp-cta"
            className="btn-whatsapp mt-7 inline-flex"
          >
            Confirmar entrega no meu endereço
          </a>
        </div>

        <div className="lg:col-span-7">
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
            {CEMITERIOS.map((c) => (
              <li key={c} className="flex items-start gap-2.5 text-sm text-[#1C1C1C] py-1.5 border-b border-[#F0EDE3] last:border-b-0">
                <MapPin className="h-4 w-4 text-[#BFA573] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>{c}</span>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-[#5C5C5C]">
            + capelas, hospitais, residências e endereços particulares em todo o município do Rio.
          </p>
        </div>
      </div>
    </section>
  );
};
